import React, { useState } from "react";
import axios from "axios"; // Import axios for API calls
import { Rating, Stack } from "@mui/material";
import "./Style.css";
import cl35 from "../../assets/cl35.png";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-coverflow";
import logo from "../../assets/navlogo.png";


function Contact({ onAddFeedback }) {
  const [formData, setFormData] = useState({
    nom: "",
    avis: "",
    numberChoice: 0,
  });
  const [rating, setRating] = useState(0);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (rating < 1) {
      alert("Veuillez sélectionner une note valide.");
      return;
    }

    const feedback = { ...formData, numberChoice: rating };
    console.log("feedback: ", feedback);
    // Send feedback to the Node.js backend using axios
    try {
      const response = await axios.post('https://ecd-full-website-2.onrender.com/api/feedbacks', feedback);
      onAddFeedback(response.data); // Add the feedback to the parent state
      setFormData({ nom: "", avis: "", numberChoice: 0 }); // Reset form
      setRating(0); // Reset rating
    } catch (error) {
      console.error("There was an error submitting the feedback:", error);
    }
  };


  return (
    <div className="Contact">
    <div className="hidden-text">
    <h1>dentiste setif</h1>
    <h1>dentiste Algerie</h1>
    <h1>dentiste N'gaous</h1>
    <h1>dentiste Ngaous</h1>
    <h1>dentiste Ngaous Batna</h1>
    <h1>dentiste Biskra</h1>
    <h1>dentiste Batna</h1>
    <h1>dentiste Khenchlaa</h1>
    <h1>dentiste Constantine</h1>
    <h1>dentiste Oum El Bouaghi</h1>
    <h1>dentiste ngaous </h1>
    <h1>dentiste Batna</h1>
    <h1>dentiste M'sila</h1>
    <h1>dentiste Msila</h1>
    <h1>dentiste Alger</h1>
    <h1>dentiste Algerie</h1>
    <h1>soins dentaires</h1>
    <h1>orthodontie, implants, esthétique dentaire, chirurgie orale, blanchiment, hygiène dentaire, urgence dentaire, Algérie</h1></div>
      <div className="Contact-container1">
        <img src={cl35} alt="Contact" />
        <div className="Contact-container11">
          <div className="Contact-text">
            <h1>Notre Contact</h1>
            <h2>EXCELLENCE CENTRE DENTAIRE</h2>
          </div>
        </div>
      </div>
      <div className="Contact-container2">
        <div className="Contact-caption">
          <h3>Contact et Avis</h3>
        </div>
        <div className="avis-card">
          <h2>Donnez-nous votre avis</h2>

          <div className="avis-infos">
            <form onSubmit={handleSubmit}>
              <div className="avis-infos-form">
                <label className="avis-infos-label" htmlFor="nom">Nom</label>
                <input
                  className="nominput"
                  type="text"
                  id="nom"
                  name="nom"
                  placeholder="Entrez votre nom"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                />
                <label className="avis-infos-label" htmlFor="avis">Avis</label>
                <input
                  className="avisinput"
                  type="text"
                  id="avis"
                  name="avis"
                  placeholder="Entrez votre avis"
                  value={formData.avis}
                  onChange={handleChange}
                  required
                />
                <label className="avis-infos-label" htmlFor="numberChoice">Notez-nous:</label>
                <Stack spacing={1}>
                  <Rating
                    name="simple-controlled"
                    value={rating}
                    onChange={(event, newRating) => {
                      setRating(newRating);
                    }}
                  />
                </Stack>
                <button type="submit">Envoyez</button>
              </div>
            </form>
            
            <div className="avis-bar"></div>
            <a href="https://g.page/r/CVOeFltIcuRyEBM/review" target="_blank">
              <div className="avis-googlemaps">
                <p>
                  Donnez-nous votre avis sur <span>Google Maps</span>, cela nous
                  aidera ainsi que nos futurs clients.
                </p>
                <div className="google-maps-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="65"
                    viewBox="0 0 45 65"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_629_437)">
                      <path
                        d="M12.4082 47.8809C14.2739 50.2633 15.9719 52.7727 17.4902 55.391C18.7864 57.8536 19.3268 59.5234 20.2741 62.4905C20.855 64.1298 21.3801 64.6191 22.5089 64.6191C23.7391 64.6191 24.2972 63.7867 24.7284 62.4995C25.6238 59.6974 26.3264 57.5589 27.4349 55.5383C29.61 51.6372 32.3128 48.1706 34.9685 44.8389C35.6874 43.896 40.3358 38.4026 42.4285 34.0681C42.4285 34.0681 45.0005 29.3067 45.0005 22.6569C45.0005 16.4366 42.464 12.1226 42.464 12.1226L35.1612 14.0821L30.7262 25.7855L29.629 27.3993L29.4096 27.6916L29.1178 28.0576L28.6056 28.6422L27.8736 29.3754L23.9243 32.5991L14.0507 38.311L12.4082 47.8809Z"
                        fill="#34A853"
                      />
                      <path
                        d="M2.2168 33.2677C4.62658 38.7826 9.27354 43.6305 12.4176 47.8848L29.117 28.0652C29.117 28.0652 26.7643 31.1481 22.4967 31.1481C17.743 31.1481 13.9027 27.3447 13.9027 22.549C13.9027 19.2603 15.8775 17.001 15.8775 17.001L4.5415 20.0443L2.2168 33.2677Z"
                        fill="#FBBC04"
                      />
                      <path
                        d="M29.3044 1.01904C34.8507 2.81072 39.5978 6.57213 42.4692 12.1187L29.123 28.0538C29.123 28.0538 31.0978 25.7536 31.0978 22.4854C31.0978 17.5779 26.9734 13.9118 22.5179 13.9118C18.3046 13.9118 15.8848 16.9895 15.8848 16.9895V6.95062L29.3044 1.01904Z"
                        fill="#4285F4"
                      />
                      <path
                        d="M5.27539 8.06017C8.58799 4.08917 14.4169 0 22.4529 0C26.3517 0 29.289 1.02555 29.289 1.02555L15.8706 16.9985H6.36348L5.27539 8.06017Z"
                        fill="#1A73E8"
                      />
                      <path
                        d="M2.21695 33.2677C2.21695 33.2677 0 28.9179 0 22.6163C0 16.6604 2.31082 11.4543 5.27607 8.06006L15.8788 16.9998L2.21695 33.2677Z"
                        fill="#EA4335"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_629_437">
                        <rect width="45" height="64.6364" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="Contact-container3">
          <div className="Contact-container31">
            <h2>Plan d'accès</h2>
            <div className="Contact-container31-bar"></div>
            <div className="Contact-container31-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="57"
                height="50"
                viewBox="0 0 57 50"
                fill="none"
              >
                <g clip-path="url(#clip0_629_484)">
                  <path
                    d="M28.1828 11.2305L6.79886 30.0498C6.64034 30.1924 6.43778 30.2588 6.2636 30.3769V48.4375C6.2636 48.8519 6.42855 49.2493 6.72217 49.5424C7.01579 49.8354 7.41402 50 7.82926 50H48.5363C48.9516 50 49.3498 49.8354 49.6434 49.5424C49.937 49.2493 50.102 48.8519 50.102 48.4375V30.3809C49.9356 30.2676 49.738 30.2031 49.5873 30.0684L28.1828 11.2305ZM37.5767 36.7187C37.5767 36.9259 37.4943 37.1247 37.3474 37.2712C37.2006 37.4177 37.0015 37.5 36.7939 37.5H31.3141V42.9687C31.3141 43.1759 31.2316 43.3747 31.0848 43.5212C30.938 43.6677 30.7389 43.75 30.5313 43.75H25.8343C25.6267 43.75 25.4276 43.6677 25.2808 43.5212C25.134 43.3747 25.0515 43.1759 25.0515 42.9687V37.5H19.5717C19.3641 37.5 19.1649 37.4177 19.0181 37.2712C18.8713 37.1247 18.7889 36.9259 18.7889 36.7187V32.0312C18.7889 31.824 18.8713 31.6253 19.0181 31.4788C19.1649 31.3323 19.3641 31.25 19.5717 31.25H25.0515V25.7812C25.0515 25.574 25.134 25.3753 25.2808 25.2288C25.4276 25.0823 25.6267 25 25.8343 25H30.5313C30.7389 25 30.938 25.0823 31.0848 25.2288C31.2316 25.3753 31.3141 25.574 31.3141 25.7812V31.25H36.7939C37.0015 31.25 37.2006 31.3323 37.3474 31.4788C37.4943 31.6253 37.5767 31.824 37.5767 32.0312V36.7187ZM55.845 23.0742L30.8004 1.0039C30.0835 0.357125 29.1516 -0.000976562 28.1852 -0.000976562C27.2189 -0.000976562 26.2869 0.357125 25.5701 1.0039L0.519597 23.0742C0.366575 23.2113 0.242124 23.3772 0.153354 23.5624C0.064584 23.7475 0.0132346 23.9483 0.00223926 24.1532C-0.00875614 24.3582 0.0208179 24.5633 0.0892718 24.7569C0.157726 24.9504 0.263718 25.1286 0.401194 25.2812L2.49624 27.6074C2.63365 27.7601 2.79986 27.8843 2.98538 27.9729C3.1709 28.0615 3.37209 28.1128 3.57745 28.1237C3.78282 28.1347 3.98834 28.1052 4.18228 28.0369C4.37622 27.9686 4.55477 27.8628 4.70773 27.7256L27.1475 7.97167C27.4335 7.71984 27.8018 7.58088 28.1833 7.58088C28.5647 7.58088 28.933 7.71984 29.2191 7.97167L51.6588 27.7246C51.8118 27.8618 51.9903 27.9676 52.1843 28.0359C52.3782 28.1042 52.5837 28.1337 52.7891 28.1228C52.9945 28.1118 53.1957 28.0605 53.3812 27.9719C53.5667 27.8834 53.7329 27.7592 53.8703 27.6064L55.9644 25.2803C56.2416 24.9719 56.3848 24.5663 56.3624 24.1526C56.34 23.7389 56.1539 23.351 55.845 23.0742Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_629_484">
                    <rect width="56.3636" height="50" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div className="Contact-container31-elem-text">
                <h3>Adresse:</h3>
                <p>N’GAOUS, BATNA, ALGERIE</p>
              </div>
            </div>
            <div className="Contact-container31-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
              >
                <path
                  d="M13.7917 22.4792C16.7917 28.375 21.625 33.1875 27.5208 36.2083L32.1042 31.625C32.6667 31.0625 33.5 30.875 34.2292 31.125C36.5625 31.8958 39.0833 32.3125 41.6667 32.3125C42.8125 32.3125 43.75 33.25 43.75 34.3958V41.6667C43.75 42.8125 42.8125 43.75 41.6667 43.75C22.1042 43.75 6.25 27.8958 6.25 8.33333C6.25 7.1875 7.1875 6.25 8.33333 6.25H15.625C16.7708 6.25 17.7083 7.1875 17.7083 8.33333C17.7083 10.9375 18.125 13.4375 18.8958 15.7708C19.125 16.5 18.9583 17.3125 18.375 17.8958L13.7917 22.4792Z"
                  fill="white"
                />
              </svg>
              <div className="Contact-container31-elem-text">
                <h3>Téléphone</h3>
                <p>+213663 535 252 +213 333 775 00</p>
              </div>
            </div>
            <div className="Contact-container31-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
              >
                <path
                  d="M32.2917 25H25V14.5833M6.25 25C6.25 27.4623 6.73498 29.9005 7.67726 32.1753C8.61953 34.4502 10.0006 36.5172 11.7417 38.2582C13.4828 39.9993 15.5498 41.3805 17.8247 42.3227C20.0995 43.265 22.5377 43.75 25 43.75C27.4623 43.75 29.9005 43.265 32.1753 42.3227C34.4502 41.3805 36.5172 39.9993 38.2582 38.2582C39.9993 36.5172 41.3805 34.4502 42.3227 32.1753C43.265 29.9005 43.75 27.4623 43.75 25C43.75 22.5377 43.265 20.0995 42.3227 17.8247C41.3805 15.5498 39.9993 13.4828 38.2582 11.7417C36.5172 10.0006 34.4502 8.61953 32.1753 7.67726C29.9005 6.73498 27.4623 6.25 25 6.25C22.5377 6.25 20.0995 6.73498 17.8247 7.67726C15.5498 8.61953 13.4828 10.0006 11.7417 11.7417C10.0006 13.4828 8.61953 15.5498 7.67726 17.8247C6.73498 20.0995 6.25 22.5377 6.25 25Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div className="Contact-container31-elem-text">
                <h3>Horaires:</h3>
                <p>Tous les jours de 08.00 a 18.00</p>
              </div>
            </div>
            <div className="Contact-container31-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
              >
                <path
                  d="M20.9532 0.00233763C22.3396 -0.00298252 23.7261 0.0109516 25.1121 0.0441356L25.4807 0.0574349C25.9063 0.0726341 26.3261 0.0916331 26.8334 0.114432C28.8549 0.209427 30.2342 0.528611 31.4445 0.997887C32.6984 1.48046 33.7548 2.13403 34.8111 3.19037C35.777 4.13958 36.5245 5.28777 37.0017 6.5551C37.471 7.76534 37.7902 9.14657 37.8852 11.1681C37.908 11.6734 37.9269 12.0952 37.9422 12.5208L37.9535 12.8894C37.9873 14.2748 38.0019 15.6606 37.9972 17.0464L37.9991 18.4637V20.9526C38.0038 22.339 37.9893 23.7254 37.9554 25.1115L37.944 25.48C37.9289 25.9056 37.9099 26.3255 37.8871 26.8328C37.7921 28.8543 37.4691 30.2336 37.0017 31.4438C36.5261 32.7125 35.7783 33.8616 34.8111 34.8105C33.8611 35.7762 32.7123 36.5237 31.4445 37.001C30.2342 37.4703 28.8549 37.7895 26.8334 37.8845C26.3261 37.9073 25.9063 37.9263 25.4807 37.9415L25.1121 37.9529C23.7261 37.9867 22.3397 38.0012 20.9532 37.9966L19.5359 37.9985H17.0489C15.6625 38.0032 14.2761 37.9886 12.89 37.9548L12.5215 37.9434C12.0704 37.927 11.6195 37.908 11.1687 37.8864C9.14723 37.7914 7.7679 37.4684 6.55576 37.001C5.28792 36.5248 4.13954 35.7772 3.19103 34.8105C2.22407 33.861 1.47585 32.7121 0.998545 31.4438C0.529269 30.2336 0.210085 28.8543 0.11509 26.8328C0.0939309 26.3819 0.0749317 25.931 0.0580933 25.48L0.048594 25.1115C0.0135666 23.7254 -0.00226762 22.339 0.00109625 20.9526V17.0464C-0.00420632 15.6606 0.00972778 14.2748 0.0428942 12.8894L0.0561935 12.5208C0.0713927 12.0952 0.0903917 11.6734 0.113191 11.1681C0.208186 9.14467 0.527369 7.76724 0.996645 6.5551C1.47423 5.28714 2.22391 4.13927 3.19293 3.19227C4.14078 2.22475 5.28845 1.47585 6.55576 0.997887C7.7679 0.528611 9.14533 0.209427 11.1687 0.114432L12.5215 0.0574349L12.89 0.0479356C14.2754 0.0129258 15.6612 -0.00290847 17.047 0.000437867L20.9532 0.00233763ZM19.0001 9.50185C17.7414 9.48405 16.4918 9.71658 15.3238 10.1859C14.1557 10.6553 13.0927 11.3521 12.1963 12.2359C11.2999 13.1197 10.5881 14.1728 10.1023 15.3341C9.61645 16.4954 9.36627 17.7416 9.36627 19.0004C9.36627 20.2592 9.61645 21.5055 10.1023 22.6667C10.5881 23.828 11.2999 24.8811 12.1963 25.7649C13.0927 26.6487 14.1557 27.3455 15.3238 27.8149C16.4918 28.2842 17.7414 28.5168 19.0001 28.499C21.5195 28.499 23.9358 27.4981 25.7173 25.7166C27.4988 23.9351 28.4996 21.5189 28.4996 18.9995C28.4996 16.48 27.4988 14.0638 25.7173 12.2823C23.9358 10.5008 21.5195 9.50185 19.0001 9.50185ZM19.0001 13.3017C19.7572 13.2877 20.5096 13.4248 21.2131 13.7048C21.9167 13.9849 22.5574 14.4023 23.0978 14.9328C23.6382 15.4633 24.0675 16.0961 24.3606 16.7943C24.6537 17.4926 24.8047 18.2422 24.8048 18.9994C24.805 19.7567 24.6542 20.5064 24.3613 21.2047C24.0685 21.903 23.6394 22.536 23.0991 23.0667C22.5589 23.5973 21.9184 24.015 21.2149 24.2953C20.5114 24.5756 19.7592 24.7129 19.002 24.6992C17.4904 24.6992 16.0406 24.0987 14.9717 23.0298C13.9028 21.9609 13.3023 20.5111 13.3023 18.9995C13.3023 17.4878 13.9028 16.0381 14.9717 14.9692C16.0406 13.9003 17.4904 13.2998 19.002 13.2998L19.0001 13.3017ZM28.9746 6.652C28.3617 6.67653 27.782 6.93727 27.357 7.3796C26.9321 7.82194 26.6947 8.41156 26.6947 9.02497C26.6947 9.63839 26.9321 10.228 27.357 10.6703C27.782 11.1127 28.3617 11.3734 28.9746 11.398C29.6045 11.398 30.2085 11.1477 30.6539 10.7024C31.0993 10.257 31.3495 9.65293 31.3495 9.02307C31.3495 8.39322 31.0993 7.78916 30.6539 7.34378C30.2085 6.89841 29.6045 6.6482 28.9746 6.6482V6.652Z"
                  fill="white"
                />
              </svg>
              <div className="Contact-container31-elem-text">
                <h3>Instagram:</h3>
                <p>excellencecentredentaire</p>
              </div>
            </div>
            <div className="Contact-container31-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M20 -0.000488281C31.046 -0.000488281 40 8.95351 40 19.9995C40 31.0455 31.046 39.9995 20 39.9995C16.4656 40.0052 12.9933 39.0698 9.94002 37.2895L0.00802813 39.9995L2.71203 30.0635C0.930214 27.0092 -0.00587675 23.5355 2.77605e-05 19.9995C2.77605e-05 8.95351 8.95402 -0.000488281 20 -0.000488281ZM13.184 10.5995L12.784 10.6155C12.5251 10.6313 12.272 10.6993 12.04 10.8155C11.8231 10.9384 11.625 11.092 11.452 11.2715C11.212 11.4975 11.076 11.6935 10.93 11.8835C10.1903 12.8453 9.79197 14.0261 9.79802 15.2395C9.80202 16.2195 10.058 17.1735 10.458 18.0655C11.276 19.8695 12.622 21.7795 14.398 23.5495C14.826 23.9755 15.246 24.4035 15.698 24.8015C17.9048 26.7444 20.5345 28.1456 23.378 28.8935L24.514 29.0675C24.884 29.0875 25.254 29.0595 25.626 29.0415C26.2085 29.0114 26.7772 28.8537 27.292 28.5795C27.5539 28.4446 27.8095 28.2978 28.058 28.1395C28.058 28.1395 28.144 28.0835 28.308 27.9595C28.578 27.7595 28.744 27.6175 28.968 27.3835C29.134 27.2115 29.278 27.0095 29.388 26.7795C29.544 26.4535 29.7 25.8315 29.764 25.3135C29.812 24.9175 29.798 24.7015 29.792 24.5675C29.784 24.3535 29.606 24.1315 29.412 24.0375L28.248 23.5155C28.248 23.5155 26.508 22.7575 25.444 22.2735C25.3327 22.2249 25.2134 22.1971 25.092 22.1915C24.9552 22.1774 24.8169 22.1928 24.6865 22.2367C24.5561 22.2805 24.4366 22.3517 24.336 22.4455C24.326 22.4415 24.192 22.5555 22.746 24.3075C22.663 24.419 22.5487 24.5033 22.4176 24.5496C22.2865 24.5959 22.1446 24.6021 22.01 24.5675C21.8797 24.5326 21.7521 24.4884 21.628 24.4355C21.38 24.3315 21.294 24.2915 21.124 24.2195C19.9761 23.7186 18.9134 23.0418 17.974 22.2135C17.722 21.9935 17.488 21.7535 17.248 21.5215C16.4612 20.768 15.7755 19.9155 15.208 18.9855L15.09 18.7955C15.0053 18.6678 14.9367 18.5301 14.886 18.3855C14.81 18.0915 15.008 17.8555 15.008 17.8555C15.008 17.8555 15.494 17.3235 15.72 17.0355C15.94 16.7555 16.126 16.4835 16.246 16.2895C16.482 15.9095 16.556 15.5195 16.432 15.2175C15.872 13.8495 15.292 12.4875 14.696 11.1355C14.578 10.8675 14.228 10.6755 13.91 10.6375C13.802 10.6255 13.694 10.6135 13.586 10.6055C13.3174 10.5922 13.0483 10.5948 12.78 10.6135L13.182 10.5975L13.184 10.5995Z"
                  fill="white"
                />
              </svg>
              <div className="Contact-container31-elem-text">
                <h3>WhatsApp</h3>
                <p>+213663 535 252</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-container1">
          <h2>N'hésitez pas à nous rendre visite à tout moment</h2>
          <div className="footer-container11">
            <div className="footer-infos">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
              >
                <circle cx="16.3027" cy="16.5801" r="16" fill="#3167D9" />
                <path
                  d="M16.1881 8.90039C14.5216 8.90228 12.9239 9.56514 11.7455 10.7435C10.5671 11.9219 9.90423 13.5197 9.90234 15.1862C9.90234 20.5648 15.6167 24.627 15.8603 24.797C15.9563 24.8643 16.0708 24.9004 16.1881 24.9004C16.3054 24.9004 16.4199 24.8643 16.516 24.797C16.7596 24.627 22.4739 20.5648 22.4739 15.1862C22.472 13.5197 21.8092 11.9219 20.6307 10.7435C19.4523 9.56514 17.8546 8.90228 16.1881 8.90039ZM16.1881 12.9004C16.6402 12.9004 17.0821 13.0345 17.458 13.2856C17.8339 13.5368 18.1269 13.8938 18.2999 14.3115C18.4729 14.7291 18.5181 15.1887 18.4299 15.6321C18.3417 16.0755 18.124 16.4828 17.8044 16.8024C17.4847 17.1221 17.0774 17.3398 16.634 17.428C16.1907 17.5162 15.7311 17.4709 15.3134 17.2979C14.8957 17.1249 14.5388 16.8319 14.2876 16.4561C14.0364 16.0802 13.9024 15.6382 13.9024 15.1862C13.9024 14.58 14.1432 13.9986 14.5719 13.5699C15.0005 13.1412 15.5819 12.9004 16.1881 12.9004Z"
                  fill="white"
                />
              </svg>
              <p> N’GAOUS, BATNA, ALGERIE</p>
            </div>
            <div className="footer-infos">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
              >
                <circle cx="16.4346" cy="16.5801" r="16" fill="#3167D9" />
                <path
                  d="M16.4346 8.58008C12.0165 8.58008 8.43457 12.162 8.43457 16.5801C8.43457 20.9982 12.0165 24.5801 16.4346 24.5801C20.8526 24.5801 24.4346 20.9982 24.4346 16.5801C24.4346 12.162 20.8526 8.58008 16.4346 8.58008ZM20.1269 17.8108H16.4346C16.2714 17.8108 16.1148 17.746 15.9994 17.6306C15.884 17.5152 15.8192 17.3587 15.8192 17.1955V11.657C15.8192 11.4938 15.884 11.3373 15.9994 11.2219C16.1148 11.1065 16.2714 11.0416 16.4346 11.0416C16.5978 11.0416 16.7543 11.1065 16.8697 11.2219C16.9851 11.3373 17.05 11.4938 17.05 11.657V16.5801H20.1269C20.2901 16.5801 20.4466 16.6449 20.562 16.7603C20.6774 16.8757 20.7423 17.0323 20.7423 17.1955C20.7423 17.3587 20.6774 17.5152 20.562 17.6306C20.4466 17.746 20.2901 17.8108 20.1269 17.8108Z"
                  fill="white"
                />
              </svg>
              <p>
                Tous les jours <br />
                De 08.00 a 18.00
              </p>
            </div>
            <div className="footer-infos">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
              >
                <circle cx="16.5664" cy="16.5801" r="16" fill="#3167D9" />
                <path
                  d="M26.5662 12.1152V21.5801C26.5663 22.3453 26.2739 23.0816 25.7489 23.6384C25.224 24.1951 24.5061 24.5302 23.7422 24.5751L23.5662 24.5801H9.56638C8.80117 24.5802 8.06488 24.2878 7.50814 23.7628C6.9514 23.2379 6.6163 22.52 6.57141 21.7561L6.56641 21.5801V12.1152L16.0113 18.4122L16.1273 18.4782C16.264 18.545 16.4142 18.5797 16.5663 18.5797C16.7185 18.5797 16.8686 18.545 17.0053 18.4782L17.1213 18.4122L26.5662 12.1152Z"
                  fill="white"
                />
                <path
                  d="M23.5656 8.58008C24.6456 8.58008 25.5926 9.15007 26.1206 10.0071L16.5656 16.377L7.01074 10.0071C7.26147 9.59984 7.60595 9.25847 8.01544 9.01146C8.42493 8.76444 8.88756 8.61893 9.36472 8.58708L9.56572 8.58008H23.5656Z"
                  fill="white"
                />
              </svg>
              <p>
                CLINIQUEEXCELLENCE
                <br />
                @gmail.cm
              </p>
            </div>
            <div className="footer-infos">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
              >
                <circle cx="16.6973" cy="16.5801" r="16" fill="#3167D9" />
                <path
                  d="M23.7639 24.5801C21.8528 24.5801 19.99 24.154 18.1755 23.3019C16.361 22.4497 14.7536 21.3238 13.3533 19.9241C11.953 18.5244 10.827 16.917 9.97549 15.1019C9.12393 13.2867 8.69786 11.4239 8.69727 9.51341C8.69727 9.24674 8.78615 9.02452 8.96393 8.84674C9.14171 8.66897 9.36393 8.58008 9.6306 8.58008H13.2306C13.438 8.58008 13.6232 8.64674 13.7862 8.78008C13.9491 8.91341 14.0454 9.08378 14.075 9.29119L14.6528 12.4023C14.6825 12.6097 14.6786 12.7987 14.6413 12.9694C14.6039 13.1401 14.5189 13.2918 14.3862 13.4245L12.2528 15.6023C12.875 16.669 13.6528 17.669 14.5862 18.6023C15.5195 19.5356 16.5491 20.343 17.675 21.0245L19.7639 18.9356C19.8973 18.8023 20.0715 18.7024 20.2866 18.6361C20.5017 18.5697 20.7127 18.551 20.9195 18.5801L23.9862 19.2023C24.1936 19.2467 24.3639 19.3469 24.4973 19.5027C24.6306 19.6586 24.6973 19.8399 24.6973 20.0467V23.6467C24.6973 23.9134 24.6084 24.1356 24.4306 24.3134C24.2528 24.4912 24.0306 24.5801 23.7639 24.5801Z"
                  fill="white"
                />
              </svg>
              <p>
                +213663 535 252
                <br />
                +213 333 775 00
              </p>
            </div>
          </div>
        </div>
        <div className="footer-container2">
          <div className="footer-element1">
            <img src={logo} alt="Accueil" />
          </div>
          <div className="footer-element2">
            <ul id="menuList">
              <li>
                <a href="#Accueil" className="font-semibold pb-6">
                  Accueil
                </a>
              </li>
              <li>
                <a href="#Equipe" className="font-semibold">
                  Contact
                </a>
              </li>
              <li>
                <a href="#Contact" className="font-semibold">
                  Equipe
                </a>
              </li>
              <li>
                <a href="#Aboutus" className="font-semibold">
                  Traitements
                </a>
              </li>
              <li>
                <a href="#contact" className="font-semibold">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-element3">
            <div className="footer-element31">
              <a href="#Accueil">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                  <path
                    d="M22.3641 8.63606C24.0164 10.2882 24.9614 12.5182 24.9993 14.8545C25.0372 17.1908 24.1649 19.4502 22.5671 21.1551L22.3641 21.3651L18.1211 25.6071C17.5827 26.1451 16.8599 26.4584 16.0992 26.4834C15.3385 26.5085 14.5967 26.2435 14.0241 25.7421L13.8801 25.6071L9.63606 21.3641C7.94822 19.6762 7 17.387 7 15.0001C7 12.6131 7.94822 10.3239 9.63606 8.63606C11.3239 6.94822 13.6131 6 16.0001 6C18.387 6 20.6762 6.94822 22.3641 8.63606ZM16.0001 12.0001C15.6061 12.0001 15.216 12.0777 14.852 12.2284C14.488 12.3792 14.1573 12.6002 13.8787 12.8787C13.6002 13.1573 13.3792 13.488 13.2284 13.852C13.0777 14.216 13.0001 14.6061 13.0001 15.0001C13.0001 15.394 13.0777 15.7841 13.2284 16.1481C13.3792 16.5121 13.6002 16.8428 13.8787 17.1214C14.1573 17.4 14.488 17.6209 14.852 17.7717C15.216 17.9225 15.6061 18.0001 16.0001 18.0001C16.7957 18.0001 17.5588 17.684 18.1214 17.1214C18.684 16.5588 19.0001 15.7957 19.0001 15.0001C19.0001 14.2044 18.684 13.4413 18.1214 12.8787C17.5588 12.3161 16.7957 12.0001 16.0001 12.0001Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
            <div className="footer-element31">
              <a href="#Accueil">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                  <path
                    d="M16.7197 9.50086C17.2305 9.4989 17.7413 9.50403 18.252 9.51626L18.3878 9.52116C18.5446 9.52676 18.6993 9.53376 18.8862 9.54216C19.6309 9.57716 20.1391 9.69475 20.585 9.86765C21.047 10.0454 21.4362 10.2862 21.8254 10.6754C22.1812 11.0251 22.4566 11.4482 22.6324 11.9151C22.8053 12.361 22.9229 12.8698 22.9579 13.6146C22.9663 13.8008 22.9733 13.9562 22.9789 14.113L22.9831 14.2488C22.9956 14.7592 23.0009 15.2698 22.9992 15.7803L22.9999 16.3025V17.2195C23.0017 17.7303 22.9963 18.2411 22.9838 18.7517L22.9796 18.8875C22.974 19.0443 22.967 19.199 22.9586 19.3859C22.9236 20.1307 22.8046 20.6389 22.6324 21.0848C22.4572 21.5522 22.1817 21.9756 21.8254 22.3251C21.4754 22.6809 21.0521 22.9563 20.585 23.1322C20.1391 23.3051 19.6309 23.4227 18.8862 23.4577C18.6993 23.4661 18.5446 23.4731 18.3878 23.4787L18.252 23.4829C17.7413 23.4953 17.2305 23.5007 16.7197 23.499L16.1976 23.4997H15.2813C14.7705 23.5014 14.2597 23.496 13.749 23.4836L13.6132 23.4794C13.4471 23.4734 13.2809 23.4664 13.1149 23.4584C12.3701 23.4234 11.8619 23.3044 11.4153 23.1322C10.9482 22.9567 10.5251 22.6813 10.1757 22.3251C9.81941 21.9753 9.54374 21.552 9.36789 21.0848C9.195 20.6389 9.0774 20.1307 9.0424 19.3859C9.03461 19.2198 9.02761 19.0537 9.0214 18.8875L9.0179 18.7517C9.005 18.2411 8.99916 17.7303 9.0004 17.2195V15.7803C8.99845 15.2698 9.00358 14.7592 9.0158 14.2488L9.0207 14.113C9.0263 13.9562 9.0333 13.8008 9.0417 13.6146C9.0767 12.8691 9.1943 12.3617 9.36719 11.9151C9.54315 11.4479 9.81935 11.025 10.1764 10.6761C10.5256 10.3197 10.9484 10.0437 11.4153 9.86765C11.8619 9.69475 12.3694 9.57716 13.1149 9.54216L13.6132 9.52116L13.749 9.51766C14.2595 9.50476 14.77 9.49893 15.2806 9.50016L16.7197 9.50086ZM16.0002 13.0007C15.5364 12.9942 15.076 13.0799 14.6457 13.2528C14.2154 13.4257 13.8237 13.6824 13.4934 14.008C13.1632 14.3337 12.901 14.7217 12.722 15.1495C12.543 15.5773 12.4508 16.0365 12.4508 16.5003C12.4508 16.964 12.543 17.4232 12.722 17.851C12.901 18.2789 13.1632 18.6669 13.4934 18.9925C13.8237 19.3181 14.2154 19.5748 14.6457 19.7478C15.076 19.9207 15.5364 20.0064 16.0002 19.9998C16.9284 19.9998 17.8186 19.6311 18.475 18.9747C19.1313 18.3184 19.5 17.4281 19.5 16.4999C19.5 15.5717 19.1313 14.6815 18.475 14.0251C17.8186 13.3688 16.9284 13.0007 16.0002 13.0007ZM16.0002 14.4007C16.2791 14.3956 16.5563 14.4461 16.8155 14.5492C17.0747 14.6524 17.3108 14.8062 17.5099 15.0017C17.709 15.1971 17.8671 15.4302 17.9751 15.6875C18.0831 15.9447 18.1387 16.2209 18.1388 16.4999C18.1388 16.7789 18.0833 17.0551 17.9754 17.3124C17.8675 17.5697 17.7094 17.8029 17.5104 17.9984C17.3113 18.1939 17.0753 18.3478 16.8161 18.451C16.557 18.5543 16.2798 18.6049 16.0009 18.5999C15.4439 18.5999 14.9098 18.3786 14.516 17.9848C14.1222 17.591 13.9009 17.0569 13.9009 16.4999C13.9009 15.943 14.1222 15.4089 14.516 15.015C14.9098 14.6212 15.4439 14.4 16.0009 14.4L16.0002 14.4007ZM19.675 11.9508C19.4492 11.9598 19.2357 12.0559 19.0791 12.2188C18.9225 12.3818 18.8351 12.599 18.8351 12.825C18.8351 13.051 18.9225 13.2683 19.0791 13.4312C19.2357 13.5942 19.4492 13.6903 19.675 13.6993C19.9071 13.6993 20.1297 13.6071 20.2937 13.443C20.4578 13.279 20.55 13.0564 20.55 12.8243C20.55 12.5923 20.4578 12.3697 20.2937 12.2057C20.1297 12.0416 19.9071 11.9494 19.675 11.9494V11.9508Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
            <div className="footer-element31">
              <a href="#Accueil">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                  <path
                    d="M16.9 17.55H18.65L19.35 14.75H16.9V13.35C16.9 12.629 16.9 11.95 18.3 11.95H19.35V9.598C19.1218 9.5679 18.2601 9.5 17.3501 9.5C15.4496 9.5 14.1 10.6599 14.1 12.79V14.75H12V17.55H14.1V23.5H16.9V17.55Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
            <div className="footer-element31">
              <a href="#Accueil">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                >
                  <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                  <path
                    d="M16 9.5C19.8661 9.5 23 12.6339 23 16.5C23 20.3661 19.8661 23.5 16 23.5C14.763 23.502 13.5477 23.1746 12.479 22.5515L9.00281 23.5L9.94921 20.0224C9.32557 18.9534 8.99794 17.7376 9.00001 16.5C9.00001 12.6339 12.1339 9.5 16 9.5ZM13.6144 13.21L13.4744 13.2156C13.3838 13.2211 13.2952 13.2449 13.214 13.2856C13.1381 13.3286 13.0688 13.3824 13.0082 13.4452C12.9242 13.5243 12.8766 13.5929 12.8255 13.6594C12.5666 13.996 12.4272 14.4093 12.4293 14.834C12.4307 15.177 12.5203 15.5109 12.6603 15.8231C12.9466 16.4545 13.4177 17.123 14.0393 17.7425C14.1891 17.8916 14.3361 18.0414 14.4943 18.1807C15.2667 18.8607 16.1871 19.3511 17.1823 19.6129L17.5799 19.6738C17.7094 19.6808 17.8389 19.671 17.9691 19.6647C18.173 19.6542 18.372 19.599 18.5522 19.503C18.6439 19.4558 18.7333 19.4044 18.8203 19.349C18.8203 19.349 18.8504 19.3294 18.9078 19.286C19.0023 19.216 19.0604 19.1663 19.1388 19.0844C19.1969 19.0242 19.2473 18.9535 19.2858 18.873C19.3404 18.7589 19.395 18.5412 19.4174 18.3599C19.4342 18.2213 19.4293 18.1457 19.4272 18.0988C19.4244 18.0239 19.3621 17.9462 19.2942 17.9133L18.8868 17.7306C18.8868 17.7306 18.2778 17.4653 17.9054 17.2959C17.8664 17.2789 17.8247 17.2692 17.7822 17.2672C17.7343 17.2623 17.6859 17.2677 17.6403 17.283C17.5946 17.2983 17.5528 17.3233 17.5176 17.3561C17.5141 17.3547 17.4672 17.3946 16.9611 18.0078C16.9321 18.0468 16.892 18.0763 16.8462 18.0925C16.8003 18.1087 16.7506 18.1109 16.7035 18.0988C16.6579 18.0866 16.6132 18.0711 16.5698 18.0526C16.483 18.0162 16.4529 18.0022 16.3934 17.977C15.9917 17.8017 15.6197 17.5648 15.2909 17.2749C15.2027 17.1979 15.1208 17.1139 15.0368 17.0327C14.7614 16.769 14.5214 16.4706 14.3228 16.1451L14.2815 16.0786C14.2518 16.0339 14.2279 15.9857 14.2101 15.9351C14.1835 15.8322 14.2528 15.7496 14.2528 15.7496C14.2528 15.7496 14.4229 15.5634 14.502 15.4626C14.579 15.3646 14.6441 15.2694 14.6861 15.2015C14.7687 15.0685 14.7946 14.932 14.7512 14.8263C14.5552 14.3475 14.3522 13.8708 14.1436 13.3976C14.1023 13.3038 13.9798 13.2366 13.8685 13.2233C13.8307 13.2191 13.7929 13.2149 13.7551 13.2121C13.6611 13.2074 13.5669 13.2084 13.473 13.2149L13.6137 13.2093L13.6144 13.21Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
